/* eslint-disable no-tabs */
/* eslint-disable no-confusing-arrow */

import styled, { css } from 'styled-components';
import { theme } from '../../theme';
import { DeckType } from '../seatMapConstants';

const selectedStyle = css`
	outline: 1px solid ${theme.colors.brilliant_azure};
	outline-offset: 3px;
	background-color: ${theme.colors.b20_light_green};
`;

const wrapperColour = ({ isDisabled }) => isDisabled ? theme.colors.silver : theme.colors.w10_darkgreen;

const wrapperHeight = ({ isDoubleDecker, deckFunction }) => {
	if (deckFunction === DeckType.PASSENGER) {
		return isDoubleDecker ? '16px' : '24px';
	}

	return isDoubleDecker ? '42px' : '24px';
};

const wrapperDisplay = ({ deckFunction }) => deckFunction !== DeckType.PASSENGER
	? css`
				display: flex;
				align-items: center;
				justify-content: center;
		  `
	: css`
				cursor: pointer;

				&:focus {
					${selectedStyle}
				}
				&[aria-pressed='true'] {
					background-color: ${theme.colors.b20_light_green};
				}
				&[aria-disabled='true'] {
					pointer-events: none;
				}
		  `;

const wrapperActive = ({ isActive }) => isActive ? selectedStyle : '';

export const Wrapper = styled.div`
	background-color: ${wrapperColour};
	border-radius: 2px;
	height: ${wrapperHeight};
	${wrapperDisplay}
	${wrapperActive}
    margin-bottom: 10px;
`;

export const CoachWrapper = styled.div`
	display: grid;
	height: ${({ isDoubleDecker }) => isDoubleDecker ? '12px' : '18px'};
	padding: 2px;
	grid-template-columns: repeat(4, 1fr);
	grid-template-rows: 40% 60%;
	column-gap: 2px;
	row-gap: 1px;
	margin-top: ${({ isDoubleDecker }) => isDoubleDecker ? '' : '1px'};

	.stars {
		grid-row: 2;
		grid-column: 2/4;
		justify-self: center;
		display: flex;
		align-self: center;
	}
`;

export const Window = styled.div`
	background-color: ${theme.colors.white};
	border-radius: 2px;
	height: ${({ isDoubleDecker }) => isDoubleDecker ? '5px' : '8px'};
`;

export const IconWrapper = styled.div`
	width: 24px;
	height: 24px;

	svg {
		path {
			fill: ${theme.colors.white};
		}
	}
`;
